// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topic-pairs-tabs__header {
  display: flex;
  margin: 1.5rem 4rem;
  height: 4rem;
  max-height: 4rem;
}

.topic-pairs-tabs__actions {
  border-bottom: 1px solid rgb(161, 161, 161);
  margin-right: 3rem;
  height: 4rem;
  line-height: 4rem;
}

.topic-pairs-tabs__filter {
  width: 100%;
  position: relative;
}

.topic-pairs-tabs__tab-button {
  box-shadow: none;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 2px;
  background-color: transparent;
  color: #000000;
  margin: 1rem;
  cursor: pointer;
  margin-bottom: -2px;
}

.topic-pairs-tabs__tab-button.active {
    border-bottom: 2px solid #26a69a;
    padding-bottom: 0.9rem;
    font-weight: bold;
}

.topic-pairs-tabs__tab-button.disabled {
  cursor: not-allowed;
}

.topic-pairs-tabs__button {
  margin-left: 0.4rem;
  margin-right: 0.4rem;
}

.topic-pairs-tabs__button-create {
  background-color: #26a69a;
  margin-left: 2.7rem;
}

.topic-pairs-tabs__button-cancel-create {
  background-color: #d22e37;
}

.topic-pairs-tabs__buttons-header {
  display: flex;
}

.topic-pairs-tabs__topic-pair-items {
  height: calc(100vh - 15rem);
  overflow: auto;
  padding: 0 1rem;
}

.topic-pairs-tabs__paging {
  padding: 0 1rem;
}

.topic-pairs-tabs__button-pending {
    background-color: #1976d2;
    display: flex;
    gap: 0.4rem;
    margin-left: 2.7rem;
}

.topic-pairs-tabs__button-delete {
    background-color: #d22e37;
    display: flex;
    gap: 0.4rem;
}`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/topic-pairs-tabs/TopicPairsTabs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,WAAW;AACf","sourcesContent":[".topic-pairs-tabs__header {\r\n  display: flex;\r\n  margin: 1.5rem 4rem;\r\n  height: 4rem;\r\n  max-height: 4rem;\r\n}\r\n\r\n.topic-pairs-tabs__actions {\r\n  border-bottom: 1px solid rgb(161, 161, 161);\r\n  margin-right: 3rem;\r\n  height: 4rem;\r\n  line-height: 4rem;\r\n}\r\n\r\n.topic-pairs-tabs__filter {\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n\r\n.topic-pairs-tabs__tab-button {\r\n  box-shadow: none;\r\n  border-top-right-radius: 2px;\r\n  border-bottom-right-radius: 0px;\r\n  border-bottom-left-radius: 0px;\r\n  border-top-left-radius: 2px;\r\n  background-color: transparent;\r\n  color: #000000;\r\n  margin: 1rem;\r\n  cursor: pointer;\r\n  margin-bottom: -2px;\r\n}\r\n\r\n.topic-pairs-tabs__tab-button.active {\r\n    border-bottom: 2px solid #26a69a;\r\n    padding-bottom: 0.9rem;\r\n    font-weight: bold;\r\n}\r\n\r\n.topic-pairs-tabs__tab-button.disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.topic-pairs-tabs__button {\r\n  margin-left: 0.4rem;\r\n  margin-right: 0.4rem;\r\n}\r\n\r\n.topic-pairs-tabs__button-create {\r\n  background-color: #26a69a;\r\n  margin-left: 2.7rem;\r\n}\r\n\r\n.topic-pairs-tabs__button-cancel-create {\r\n  background-color: #d22e37;\r\n}\r\n\r\n.topic-pairs-tabs__buttons-header {\r\n  display: flex;\r\n}\r\n\r\n.topic-pairs-tabs__topic-pair-items {\r\n  height: calc(100vh - 15rem);\r\n  overflow: auto;\r\n  padding: 0 1rem;\r\n}\r\n\r\n.topic-pairs-tabs__paging {\r\n  padding: 0 1rem;\r\n}\r\n\r\n.topic-pairs-tabs__button-pending {\r\n    background-color: #1976d2;\r\n    display: flex;\r\n    gap: 0.4rem;\r\n    margin-left: 2.7rem;\r\n}\r\n\r\n.topic-pairs-tabs__button-delete {\r\n    background-color: #d22e37;\r\n    display: flex;\r\n    gap: 0.4rem;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
